// src/components/services/ServiceConfigPanel.tsx
// Shell wrapper for service-specific configurators.

import { Link } from 'react-router-dom';
import { useI18n } from '@react/hooks';

interface ServiceConfigPanelProps {
  serviceTitle: string;
  backPath: string;
  children: React.ReactNode;
}

export function ServiceConfigPanel({ serviceTitle, backPath, children }: ServiceConfigPanelProps) {
  const { t } = useI18n();

  return (
    <div className="space-y-6">
      {/* Back navigation */}
      <div>
        <Link
          to={backPath}
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4">
            <path d="M19 12H5" strokeLinecap="round" /><path d="M12 19l-7-7 7-7" strokeLinecap="round" />
          </svg>
          {t('services.backToServices')}
        </Link>
      </div>

      {/* Title */}
      <div>
        <h1 className="text-2xl font-bold text-foreground">{serviceTitle}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('services.configureDescription')}</p>
      </div>

      {/* Service-specific content */}
      {children}
    </div>
  );
}
